import type { Config } from "@jti/fe-common";
import { getConfig } from "@jti/fe-common";

import type { SelectedCountriesType } from "./MapTypes";

export class MapApi {
  readonly name = "MapApi";
  private readonly config: Config;

  private constructor(config: Config) {
    this.config = config;
  }

  // TODO(remove default in DESP-160380): getConfig() default keeps existing callers backward compatible until they pass config.
  static init(config: Config = getConfig()): MapApi {
    return new MapApi(config);
  }

  async getSelectedCountries(countriesApiUrl?: string): Promise<SelectedCountriesType[]> {
    return await fetch(countriesApiUrl || this.config.PLATFORM_CONFIGURATION_URL).then((response) => response.json());
  }
}
